import { routerStyxie } from '@/router/styxieBridge'

// The router mounts this page. Rails sends no styxie payload.
Styxie.Initializers.MlapSettingsReviewSentiment = routerStyxie({ actions: ['show']})
